import { render } from "./Barcodes.vue?vue&type=template&id=ec718db6&scoped=true"
import script from "./Barcodes.vue?vue&type=script&lang=js"
export * from "./Barcodes.vue?vue&type=script&lang=js"

import "./Barcodes.vue?vue&type=style&index=0&id=ec718db6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec718db6"]])

export default __exports__